import { makeStyles } from '@material-ui/core';

export const useFormStyles = makeStyles(() => ({
  title: {
    fontSize: 16,
    textAlign: 'center',
  },
}));
